import { type FormFieldElement, GenderEnum, StudentTypes } from '~/types/form'

export type PersonalDetailsFormField = 'firstName' | 'lastName' | 'phone' | 'gender' | 'dateOfBirth'
export type UpdatePasswordFormField = 'currentPassword' | 'newPassword'
export type UpdateStudentEmailFormField = 'studentEmail'

export const PHONE_NUM_LENGTH = 10

export const studentOptions = Object.entries(StudentTypes)
  .filter(([_, val]) => typeof val === 'number')
  .map(([key, val]) => ({ id: val, value: key }))

export const genderOptions = Object.entries(GenderEnum)
  .filter(([_, val]) => typeof val === 'number')
  .map(([key, val]) => ({ id: val, value: key }))

export const detailsFormLabels: Record<PersonalDetailsFormField, FormFieldElement> = {
  firstName: {
    label: 'First Name',
    placeholder: 'First Name'
  },
  lastName: {
    label: 'Last Name',
    placeholder: 'Last Name'
  },
  phone: {
    label: 'Phone No. (e.g. 04XXXXXXXX)',
    placeholder: '04XXXXXXXX'
  },
  gender: {
    label: 'Gender'
  },
  dateOfBirth: {
    label: 'Date of Birth',
    placeholder: 'DD/MM/YYYY',
    helper: 'Unlock bonus snack chips EVERY DAY of your birthday month.'
  }
}

export const updatePasswordFormLabels: Record<UpdatePasswordFormField, FormFieldElement> = {
  currentPassword: {
    label: 'Current Password'
  },
  newPassword: {
    label: 'Your New Password'
  }
}

export const updateStudentEmailFormLabels: Record<UpdateStudentEmailFormField, FormFieldElement> = {
  studentEmail: {
    label: 'Student Email',
    helper:
      'Email address is used for verification purposes only.\nEmail will not be stored or used for marketing communication.'
  }
}
